import { render, staticRenderFns } from "./screenshotH5.vue?vue&type=template&id=7d797071"
import script from "./screenshotH5.vue?vue&type=script&lang=js"
export * from "./screenshotH5.vue?vue&type=script&lang=js"
import style0 from "./screenshotH5.vue?vue&type=style&index=0&id=7d797071&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports